import City from '@/components/common/city/city.vue'
import chooseCity from '@/components/common/chooseCity/chooseCity.vue'
import fileUpload from '@/components/common/fileUpload/fileUpload.vue'
import myViewer from '@/components/common/myViewer/myViewer.vue'
import mySelect from '@/components/common/mySelect/mySelect.vue'
import myInput from '@/components/common/myInput/myInput.vue'
import message from '@/components/common/message/message.vue'
import fileContainer from '@/components/common/fileContainer/fileContainer.vue'
import tianyancha from '@/components/common/tianyancha/tianyancha.vue'
import assignTeam from '@/components/common/assignTeam/assignTeam.vue'
import foldBlock from '@/components/common/foldBlock/foldBlock.vue'
import wpsFile from '@/components/common/wpsFile/wpsFile.vue'
import logisticsInformation from '@/components/common/logisticsInformation/index.vue'
import checkboxTable from '@/components/common/checkboxTable/index.vue'
import previewFile from '@/components/common/previewFile/previewFile.vue'

const views = {
  City,
  chooseCity,
  fileUpload,
  myViewer,
  mySelect,
  myInput,
  message,
  fileContainer,
  tianyancha,
  assignTeam,
  foldBlock,
  wpsFile,
  logisticsInformation,
  checkboxTable,
  previewFile
}

const install = function(Vue) {
  Object.keys(views).forEach((key) => {
    Vue.component(key, views[key])
  })
}

const API = {
  install
}

export default API



// WEBPACK FOOTER //
// ./src/components/common/index.js